export const MAX_FILES_PER_UPLOAD = 10;
export const IMAGE_FILE_SIZE_LIMIT = 5.5 * 1024 * 1024; // 5MB + some margin

export enum FileRejectionState {
  NONE_REJECTED,
  ONE_FILE_AND_REJECTED,
  MULTIPLE_FILES_ONE_REJECTED,
  MULTIPLE_FILES_SOME_REJECTED,
  MULTIPLE_FILES_ALL_REJECTED,
}

const determineFileRejectionState = (
  rejectedFiles: File[],
  allFiles: File[],
) => {
  if (rejectedFiles.length === 0) {
    return FileRejectionState.NONE_REJECTED;
  }

  if (allFiles.length === 1) {
    return FileRejectionState.ONE_FILE_AND_REJECTED;
  }

  if (rejectedFiles.length === allFiles.length) {
    return FileRejectionState.MULTIPLE_FILES_ALL_REJECTED;
  }

  if (rejectedFiles.length === 1) {
    return FileRejectionState.MULTIPLE_FILES_ONE_REJECTED;
  }

  return FileRejectionState.MULTIPLE_FILES_SOME_REJECTED;
};

const getFilesToUpload = (files: FileList): [File[], FileRejectionState] => {
  const rejectedFiles: File[] = [];

  const slicedFiles = Array.from(files).slice(0, MAX_FILES_PER_UPLOAD);
  const filesToUpload = slicedFiles.filter((file: File): boolean => {
    if (file.size > IMAGE_FILE_SIZE_LIMIT) {
      rejectedFiles.push(file);

      return false;
    }

    return true;
  });

  const fileRejectionState = determineFileRejectionState(
    rejectedFiles,
    slicedFiles,
  );

  return [filesToUpload, fileRejectionState];
};

export default getFilesToUpload;
